module.exports = __webpack_public_path__ + "static/trove-9ac51582c3c2e755680b82bba6555768.png";